import React from 'react'
import CustomToolTip from '@Components/Tooltips/CustomToolTip'

const ContactNameTooltip = () => (
    <CustomToolTip
        type="?"
        info={
            'If you prefer to use a pseudonym or keep your name fully anonymous in the Public Work Search, you may do so by ' +
            "entering either your pseudonym or 'Anonymous' in the First Name field."
        }
        place="right"
    />
)

export default ContactNameTooltip
